(function () {
  $(function() {
    const figure = $(".js-diamondFigure");
    for (let i = 0, len = figure.length; i < len; i=(i+1)|0) {
      let listitem = figure.eq(i).children();
      let crt = 0;
      const countUp = () => {
        listitem.eq(crt).removeClass("is-crt");
        if(crt === listitem.length-1){
          crt = 0
        } else {
          crt++;
        }
        listitem.eq(crt).addClass("is-crt");
      }
      setInterval(countUp, 2000);
    }
  });
})();